module.exports = __webpack_public_path__ + "static/media/14UNEP2.af3d4816.jpg";